/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { SetPlayerDetailsRequestContentCardLevelMatrixInner } from './SetPlayerDetailsRequestContentCardLevelMatrixInner';
import {
    SetPlayerDetailsRequestContentCardLevelMatrixInnerFromJSON,
    SetPlayerDetailsRequestContentCardLevelMatrixInnerFromJSONTyped,
    SetPlayerDetailsRequestContentCardLevelMatrixInnerToJSON,
    instanceOfSetPlayerDetailsRequestContentCardLevelMatrixInner,
} from './SetPlayerDetailsRequestContentCardLevelMatrixInner';

/**
 * 
 * @export
 * @interface SetPlayerDetailsRequestContent
 */
export interface SetPlayerDetailsRequestContent {
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    preferredName: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    tier: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    tierLock: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    lockCardLevel: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    birthday: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    cellNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    addressOne: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    secondAddress: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    secondCity: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    secondState: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    secondPostcode: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    secondCountry: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    driversLicense: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    idType: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    idExpires: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    gender: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    inactive: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    playerType: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    pasDistribution: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    okToMail: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    okToEmail: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    okToCall: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    okToText: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    gamingMarketingOptIn: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    nonGamingMarketingOptIn: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    pcsoffered?: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    cardLevel: string;
    /**
     * 
     * @type {string}
     * @memberof SetPlayerDetailsRequestContent
     */
    useCardLevel: string;
    /**
     * 
     * @type {Array<SetPlayerDetailsRequestContentCardLevelMatrixInner>}
     * @memberof SetPlayerDetailsRequestContent
     */
    cardLevelMatrix?: Array<SetPlayerDetailsRequestContentCardLevelMatrixInner>;
}


/**
 * Check if a given object implements the SetPlayerDetailsRequestContent interface.
 */
export function instanceOfSetPlayerDetailsRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "preferredName" in value;
    isInstance = isInstance && "tier" in value;
    isInstance = isInstance && "tierLock" in value;
    isInstance = isInstance && "lockCardLevel" in value;
    isInstance = isInstance && "birthday" in value;
    isInstance = isInstance && "emailAddress" in value;
    isInstance = isInstance && "cellNumber" in value;
    isInstance = isInstance && "phoneNumber" in value;
    isInstance = isInstance && "addressOne" in value;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "secondAddress" in value;
    isInstance = isInstance && "secondCity" in value;
    isInstance = isInstance && "secondState" in value;
    isInstance = isInstance && "secondPostcode" in value;
    isInstance = isInstance && "secondCountry" in value;
    isInstance = isInstance && "driversLicense" in value;
    isInstance = isInstance && "idType" in value;
    isInstance = isInstance && "idExpires" in value;
    isInstance = isInstance && "gender" in value;
    isInstance = isInstance && "inactive" in value;
    isInstance = isInstance && "playerType" in value;
    isInstance = isInstance && "pasDistribution" in value;
    isInstance = isInstance && "okToMail" in value;
    isInstance = isInstance && "okToEmail" in value;
    isInstance = isInstance && "okToCall" in value;
    isInstance = isInstance && "okToText" in value;
    isInstance = isInstance && "gamingMarketingOptIn" in value;
    isInstance = isInstance && "nonGamingMarketingOptIn" in value;
    isInstance = isInstance && "cardLevel" in value;
    isInstance = isInstance && "useCardLevel" in value;
    return isInstance;
}

export function SetPlayerDetailsRequestContentFromJSON(json: any): SetPlayerDetailsRequestContent {
    return SetPlayerDetailsRequestContentFromJSONTyped(json, false);
}

export function SetPlayerDetailsRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPlayerDetailsRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'title': json['title'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'preferredName': json['preferredName'],
        'tier': json['tier'],
        'tierLock': json['tierLock'],
        'lockCardLevel': json['lockCardLevel'],
        'birthday': json['birthday'],
        'emailAddress': json['emailAddress'],
        'cellNumber': json['cellNumber'],
        'phoneNumber': json['phoneNumber'],
        'addressOne': json['addressOne'],
        'city': json['city'],
        'postcode': json['postcode'],
        'state': json['state'],
        'country': json['country'],
        'secondAddress': json['secondAddress'],
        'secondCity': json['secondCity'],
        'secondState': json['secondState'],
        'secondPostcode': json['secondPostcode'],
        'secondCountry': json['secondCountry'],
        'driversLicense': json['driversLicense'],
        'idType': json['idType'],
        'idExpires': json['idExpires'],
        'gender': json['gender'],
        'inactive': json['inactive'],
        'playerType': json['playerType'],
        'pasDistribution': json['pasDistribution'],
        'okToMail': json['okToMail'],
        'okToEmail': json['okToEmail'],
        'okToCall': json['okToCall'],
        'okToText': json['okToText'],
        'gamingMarketingOptIn': json['gamingMarketingOptIn'],
        'nonGamingMarketingOptIn': json['nonGamingMarketingOptIn'],
        'pcsoffered': !exists(json, 'pcsoffered') ? undefined : json['pcsoffered'],
        'cardLevel': json['cardLevel'],
        'useCardLevel': json['useCardLevel'],
        'cardLevelMatrix': !exists(json, 'cardLevelMatrix') ? undefined : ((json['cardLevelMatrix'] as Array<any>).map(SetPlayerDetailsRequestContentCardLevelMatrixInnerFromJSON)),
    };
}

export function SetPlayerDetailsRequestContentToJSON(value?: SetPlayerDetailsRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'title': value.title,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'preferredName': value.preferredName,
        'tier': value.tier,
        'tierLock': value.tierLock,
        'lockCardLevel': value.lockCardLevel,
        'birthday': value.birthday,
        'emailAddress': value.emailAddress,
        'cellNumber': value.cellNumber,
        'phoneNumber': value.phoneNumber,
        'addressOne': value.addressOne,
        'city': value.city,
        'postcode': value.postcode,
        'state': value.state,
        'country': value.country,
        'secondAddress': value.secondAddress,
        'secondCity': value.secondCity,
        'secondState': value.secondState,
        'secondPostcode': value.secondPostcode,
        'secondCountry': value.secondCountry,
        'driversLicense': value.driversLicense,
        'idType': value.idType,
        'idExpires': value.idExpires,
        'gender': value.gender,
        'inactive': value.inactive,
        'playerType': value.playerType,
        'pasDistribution': value.pasDistribution,
        'okToMail': value.okToMail,
        'okToEmail': value.okToEmail,
        'okToCall': value.okToCall,
        'okToText': value.okToText,
        'gamingMarketingOptIn': value.gamingMarketingOptIn,
        'nonGamingMarketingOptIn': value.nonGamingMarketingOptIn,
        'pcsoffered': value.pcsoffered,
        'cardLevel': value.cardLevel,
        'useCardLevel': value.useCardLevel,
        'cardLevelMatrix': value.cardLevelMatrix === undefined ? undefined : ((value.cardLevelMatrix as Array<any>).map(SetPlayerDetailsRequestContentCardLevelMatrixInnerToJSON)),
    };
}

